/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var EKeyboardDirection = /* @__PURE__ */function (EKeyboardDirection2) {
  EKeyboardDirection2[EKeyboardDirection2["left"] = 37] = "left";
  EKeyboardDirection2[EKeyboardDirection2["up"] = 38] = "up";
  EKeyboardDirection2[EKeyboardDirection2["right"] = 39] = "right";
  EKeyboardDirection2[EKeyboardDirection2["down"] = 40] = "down";
  return EKeyboardDirection2;
}(EKeyboardDirection || {});
var ARROW_DOWN_REG = /^ArrowDown$/i;
var ARROW_UP_REG = /^ArrowUp$/i;
var ESCAPE_REG = /^Escape$/i;
var SPACE_REG = /^Space$/i;
var ENTER_REG = /^Enter$/i;
var SHIFT_REG = /^(Shift|ShiftLeft|ShiftRight)$/i;
var CLEAR_REG = /^KeyC$/i;
var ALL_REG = /^(KeyA|KeyL)$/i;
var CHECKED_CODE_REG = /^(Enter|Space)$/i;

export { ALL_REG, ARROW_DOWN_REG, ARROW_UP_REG, CHECKED_CODE_REG, CLEAR_REG, EKeyboardDirection, ENTER_REG, ESCAPE_REG, SHIFT_REG, SPACE_REG };
//# sourceMappingURL=common.mjs.map
